import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const ratioAccommodationServiceEntity: Entity = {
  model: model,
  repository: repository,
}

export default ratioAccommodationServiceEntity
